import React from 'react'
import { IoDocumentText } from "react-icons/io5";
import { FiDownload } from "react-icons/fi";
import ReactQuill from 'react-quill';
import './readQuill.css';


function ReadingModeChatCollapse({ item, setClickedImg, setMediaMessage, setShowImagePopup }) {

  const { himself, displayName, message, id, deleted, isImage, url, isDoc, documentName, bundle } = item

  function downloadURI(uri, name) {
    // console.log(name);
    var link = document.createElement("a");
    // If you don't know the name or want to use
    // the webserver default set name = ''
    link.setAttribute('download', name);
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  return (
    <div className={`relative flex ${!himself ? "justify-end" : "justify-start"} items-start`}>

      {himself && <div className="w-[31.2px] h-[31.2px] rounded-l-xl flex items-center justify-center bg-lightPrimary shadow-md">
        <span className={`text-base font-semibold text-gray-900`}>{displayName[0]}</span>
      </div>
      }

      <div className={`flex flex-col items-end min-w-[190px] md:min-w-[100px] max-w-[75%] leading-1.5 pt-1.5 px-3 pb-4 border-gray-200 
      ${!himself ? "rounded-b-xl rounded-l-xl bg-lightSecondary" : "rounded-b-xl rounded-r-xl bg-lightPrimary"}
      dark:bg-gray-700`}>

        {bundle?.map((item) => (
          <div className='w-full flex flex-col' id={item.id} key={item.id}>

            {/* ------------------------| SHOW REPLY part */}
            {item.replyingToId &&
              <a href={`#${item.replyingToId}`}
                className={`relative w-full rounded-lg bg-gray-50 hover:bg-gray-100 ${false ? "/bg-lightSecondary" : "/bg-lightPrimary"} border border-gray-300 truncate mt-2 flex h-fit`}>

                <div className={`absolute left-0 top-0 bottom-0 w-1 ${item.replyingToDisplayName === displayName ? "bg-headPrimary" : "bg-headSecondary"}`}></div>

                <div className="w-[calc(100%-4px)] flex flex-col p-0.5 px-3 pr-4   ">

                  <div className={`text-2xs font-bold ${item.replyingToDisplayName === displayName ? "text-headPrimary" : "text-headSecondary"} mr-2`}>
                    {item.replyingToDisplayName}
                  </div>

                  <div className="text-sm truncate mt-1 ">{item.replyToMessage} </div>
                </div>
              </a>
            }

            {/* ------------------------| BOTTOM LINE: Message */}
            {
              item.quillEditorEnable ?
                <ReactQuill
                  className='w-full'
                  readOnly={true}
                  theme={"bubble"}
                  value={item.deleted ? "This Message was Deleted" : item.message} />
                :
                <p dangerouslySetInnerHTML={{ __html: item.deleted ? "This Message was Deleted" : item.message }} className={`dont-break-out text-base font-normal pt-1 lg:pt-2 text-gray-900 dark:text-white 
            ${item.deleted ? "text-red-600 italic" : ""} 
            ${!himself ? " w-fit" : "w-full text-left"}`}>
                </p>
            }

            {isImage && <div
              onClick={() => {
                setClickedImg(item.url)
                setMediaMessage(item.message)
                setShowImagePopup(true)
              }}
              className="max-w-[185px] pt-2 cursor-pointer">
              <img src={item.url} alt="" className='w-full h-auto object-cover bg-white' />
            </div>
            }
            {isDoc &&
              <div className="w-full flex">
                <div
                  onClick={() => {
                    downloadURI(item.url, item.documentName)
                  }}
                  className="cursor-pointer min-w-[50px] w-[50px] h-[50px] p-2 bg-white relative border border-gray-400 rounded-lg group mt-1 cursor-pointer">

                  <IoDocumentText className='h-full w-full group-hover:opacity-50' />

                  <div className="hidden group-hover:flex absolute top-0 bottom-0 left-0 right-0 m-auto items-center justify-center ">
                    <FiDownload className='w-8 h-8 text-headPrimary bg-lightPrimary p-1 rounded-md' />
                  </div>
                </div></div>
            }

            {/* <p dangerouslySetInnerHTML={{ __html: deleted ? "This Message was Deleted" : item.message }} className={`dont-break-out text-base font-normal text-gray-900 dark:text-white 
            ${item.deleted ? "text-red-600 italic" : ""} 
            ${!himself ? " w-fit" : "w-full text-left"}`}>
            </p>

            {isImage && <div
              onClick={() => {
                setClickedImg(item.url)
                setMediaMessage(item.message)
                setShowImagePopup(true)
              }}
              className="max-w-[185px] pt-2 cursor-pointer">
              <img src={url} alt="" className='w-full h-auto object-cover bg-white' />
            </div>
            }
            {isDoc && <div
              onClick={() => {
                downloadURI(item.url, item.documentName)
              }}
              className="cursor-pointer min-w-[50px] w-[50px] h-[50px] p-2 bg-white relative border border-gray-400 rounded-lg group mt-1 cursor-pointer">

              <IoDocumentText className='h-full w-full group-hover:opacity-50' />

              <div className="hidden group-hover:flex absolute top-0 bottom-0 left-0 right-0 m-auto items-center justify-center ">
                <FiDownload className='w-8 h-8 text-headPrimary bg-lightPrimary p-1 rounded-md' />
              </div>
            </div>
            } */}
          </div>
        ))}
      </div>

      {!himself && <div className="w-[31.2px] h-[31.2px] rounded-r-xl flex items-center justify-center bg-lightSecondary shadow-right">
        <span className={`text-base font-semibold text-gray-900`}>{displayName[0]}</span>
      </div>}

    </div>
  )
}

export default ReadingModeChatCollapse